import { Component, Vue } from 'vue-property-decorator';

import template from './mollie.vue';
import apiService from '@/services/api.service';
import store, { Action } from '@/store';
import { readableDate } from '@/utilities';
import { nl, enUS } from 'date-fns/locale';

@Component({
  mixins: [template]
})
export default class Mollie extends Vue {
  loading: boolean = true;
  paymentSuccessful: boolean = false;

  mounted() {
    this.loading = true;
    this.getPaymentStatus();
  }

  get subscriptionEnd(): string {
    return readableDate(new Date(this.$Store.state.user.subscriptionEnd), this.$i18n.locale === 'nl' ? nl : enUS);
  }

  async getPaymentStatus() {
    try {
      const result = await apiService.getPaymentStatus(this.$route.params.id);
      store.dispatch(Action.UPDATE_USERTOKEN, result);
      this.loading = false;
      this.paymentSuccessful = true;
    } catch (e) {
      this.loading = false;
      this.paymentSuccessful = false;
    }
  }
}